import React, { useMemo } from "react";
import BadgeListControl from "./BadgeListControl";
import { isGuid } from "../../helpers/CommonHelpers";

interface CaseFileIdsListControlProps {
  label: string;
  values: string[];
  onChange: (values: string[]) => void;
  disabled?: boolean;
}

const CaseFileIdsListControl: React.FC<CaseFileIdsListControlProps> = ({
  label,
  values,
  onChange,
  disabled = false,
}) => {
  const validateEntry = useMemo(
    () => (input: string) => (isGuid(input) ? input : null),
    [],
  );

  return (
    <BadgeListControl
      label={label}
      values={values}
      onChange={onChange}
      disabled={disabled}
      validateEntry={validateEntry}
      addPlaceholder="Type GUIDs, separated by comma or space…"
      tooltipText="Accepts GUIDs typed individually or separated by comma, semicolon, space, or newline."
      entityLabel="case file ids"
    />
  );
};

export default React.memo(CaseFileIdsListControl);
